import React from 'react';
import { BASE_PATHS, useModal } from '@belong/common';
import { IconMenu } from '@belong/icons';
import { ButtonBase, Link, Text } from '@belong/ui';
import clsx from 'clsx';
import css from '../../../homeowners/components/sticky-navbar/sticky-navbar.module.css';
import { BLOG_CONTENT_STRINGS } from '../../blog.strings';
import { ContentSelectModal } from '../content-select-modal/content-select-modal';
import type { ContentTableItem } from '../content-table-items/content-table-items';

type StickyNavbarProps = {
  style?: React.CSSProperties;
  tableOfContents: ContentTableItem[];
  cta?: string;
  href?: string;
};

export function StickyNavbar({
  style,
  tableOfContents,
  cta,
  href,
}: StickyNavbarProps) {
  const [isOverlayOpen, openOverlayModal, closeOverlayModal] = useModal();
  return (
    <div
      className={clsx('bg-dark-navy fixed top-0 z-50 w-full', css.container)}
      style={style}
    >
      <div className="container flex h-full items-center justify-between">
        <div>
          {tableOfContents?.length > 0 && (
            <ButtonBase
              onClick={openOverlayModal}
              className="gap-xs flex items-center"
            >
              <IconMenu
                color="white"
                width={24}
                height={18}
                aria-hidden="true"
              />
              <Text className="font-semibold uppercase text-white">
                {BLOG_CONTENT_STRINGS.contents}
              </Text>
            </ButtonBase>
          )}
          <ContentSelectModal
            isOpen={isOverlayOpen}
            onDismiss={closeOverlayModal}
            tableOfContents={tableOfContents}
          />
        </div>
        <Link href={href || BASE_PATHS.HOMEOWNER} buttonType="secondary">
          {cta || 'LEARN MORE'}
        </Link>
      </div>
    </div>
  );
}
